import type { SkeletonProps as AntDSkeletonProps } from 'antd';
import { Skeleton as AntDSkeleton } from 'antd';

import { DesignSystemAntDConfigProvider } from '../DesignSystemProvider';
import type { DangerouslySetAntdProps, HTMLDataAttributes } from '../types';

export interface SkeletonProps
  extends AntDSkeletonProps,
    DangerouslySetAntdProps<AntDSkeletonProps>,
    HTMLDataAttributes {}

interface SkeletonInterface extends React.FC<SkeletonProps> {
  Button: typeof AntDSkeleton.Button;
  Image: typeof AntDSkeleton.Image;
  Input: typeof AntDSkeleton.Input;
}

export const Skeleton = /* #__PURE__ */ (() => {
  const Skeleton: SkeletonInterface = ({ dangerouslySetAntdProps, ...props }) => {
    return (
      <DesignSystemAntDConfigProvider>
        <AntDSkeleton {...props} {...dangerouslySetAntdProps} />
      </DesignSystemAntDConfigProvider>
    );
  };

  Skeleton.Button = AntDSkeleton.Button;
  Skeleton.Image = AntDSkeleton.Image;
  Skeleton.Input = AntDSkeleton.Input;

  return Skeleton;
})();
